exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.details {\n  font-size: 0.8em;\n  font-style: italic;\n  padding: 0px;\n  margin: 0px;\n  border: none;\n  color: #005187;\n}\ntable[id*=nomargin] {\n  margin: 0px;\n  padding: 0px;\n}\ntable[id*=nomargin] tbody tr td {\n  margin: 100px;\n}\n.subtitle {\n  text-decoration: underline;\n  font-weight: bold;\n}\nh1 {\n  font-size: 1.8em;\n}\nh2 {\n  font-size: 1.4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/AccompanyingSheetDisplay.vue
// module id = 5592
// module chunks = 97